export function buildPersonSchema({ siteName, siteUrl }) {
  const repName = process.env.REACT_APP_PUBLIC_REPRESENTATIVE_NAME;
  const repUrl = process.env.REACT_APP_PUBLIC_REPRESENTATIVE_URL;
  const repJobTitle = process.env.REACT_APP_PUBLIC_REPRESENTATIVE_JOB_TITLE;

  if (!repName || !repUrl) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: repName,
    url: repUrl,
    ...(repJobTitle ? { jobTitle: repJobTitle } : {}),
    worksFor: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
    sameAs: [repUrl],
  };
}
